import { render } from "./MailVerifySigninPage.vue?vue&type=template&id=2c45629f"
import script from "./MailVerifySigninPage.vue?vue&type=script&lang=js"
export * from "./MailVerifySigninPage.vue?vue&type=script&lang=js"
script.render = render

export default script